<template>
    <v-container>
        <v-card :loading="loading">
            <v-card-title :style="{ 'background-color': '#eeeeee' }">
                <div>
                    IMPACT RATED LOUVER (ESM-5LS) LABOR COST PER MODULE<br /><span
                        class="text-body-2"
                        style="text-align: left !important;"
                        >Double click to edit</span
                    >
                </div>
                <v-spacer />
                <v-btn
                    color="primary"
                    rounded
                    @click="save"
                    :loading="loading"
                    :disabled="true"
                    >SAVE</v-btn
                >
            </v-card-title>

            <div class="table-container">
                <v-simple-table dense fixed-header :loading="loading">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th colspan="2"></th>
                                <th
                                    colspan="11"
                                    class="text-center"
                                    style="font-weight: bold;"
                                >
                                    HEIGHT
                                </th>
                            </tr>
                            <tr>
                                <th class="text-center"></th>
                                <th class="text-center">FEET</th>
                                <th class="text-center">-</th>
                                <th class="text-center">1</th>
                                <th class="text-center">2</th>
                                <th class="text-center">3</th>
                                <th class="text-center">4</th>
                                <th class="text-center">5</th>
                                <th class="text-center">6</th>
                                <th class="text-center">7</th>
                                <th class="text-center">8</th>
                                <th class="text-center">9</th>
                                <th class="text-center">10</th>
                            </tr>
                            <tr>
                                <th colspan="2"></th>
                                <th class="text-center">INCHES</th>
                                <th class="text-center">12</th>
                                <th class="text-center">24</th>
                                <th class="text-center">36</th>
                                <th class="text-center">48</th>
                                <th class="text-center">60</th>
                                <th class="text-center">72</th>
                                <th class="text-center">84</th>
                                <th class="text-center">96</th>
                                <th class="text-center">108</th>
                                <th class="text-center">120</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                v-for="(rowData, rowIndex) in tableData"
                                :key="rowData.width"
                            >
                                <td
                                    v-if="rowIndex === 0"
                                    rowspan="10"
                                    class="width-label"
                                >
                                    WIDTH
                                </td>
                                <td class="text-center">
                                    {{ rowIndex + 1 }}
                                </td>
                                <td class="text-center">
                                    {{ (rowIndex + 1) * 12 }}
                                </td>
                                <td
                                    v-for="index in Array.from(
                                        { length: 10 },
                                        (x, i) => i + 1
                                    )"
                                    :key="index"
                                    class="text-center price-cell"
                                    @dblclick="
                                        startEditing(
                                            rowIndex,
                                            `${rowData.feet}x${index}`
                                        )
                                    "
                                >
                                    <v-text-field
                                        v-if="
                                            editingCell.row === rowIndex &&
                                                editingCell.column ===
                                                    `${rowData.feet}x${index}`
                                        "
                                        v-model="
                                            rowData[`${rowData.feet}x${index}`]
                                        "
                                        outlined
                                        hide-details
                                        autofocus
                                        @blur="
                                            stopEditing(
                                                `${rowData.feet}x${index}`
                                            )
                                        "
                                        @keydown.enter="
                                            stopEditing(
                                                `${rowData.feet}x${index}`
                                            )
                                        "
                                        style="width: 90px;"
                                        type="number"
                                    ></v-text-field>
                                    <span v-else>
                                        {{
                                            formatCurrency(
                                                rowData[
                                                    `${rowData.feet}x${index}`
                                                ]
                                            )
                                        }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>
        </v-card>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'

export default {
    name: 'LouverCostTable',
    props: {
        settingId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            headers: [
                {
                    text: '',
                    value: 'width_label',
                    align: 'center',
                    sortable: false,
                },
                { text: '', value: 'width', align: 'center', sortable: false },
                { text: '', value: 'inches', align: 'center', sortable: false },
            ],
            tableData: [],
            loading: false,
            editingCell: {},
        }
    },
    async mounted() {
        try {
            await this.getItems()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async stopEditing(columnName) {
            try {
                if (this.editingCell.row == null) {
                    return null
                }
                this.loading = true
                // format the item to be edited
                this.tableData[this.editingCell.row][columnName] = Number(
                    this.tableData[this.editingCell.row][columnName]
                )
                // update the item in the API
                await API.updateLaborCostPerModule({
                    settingId: this.settingId,
                    id: this.tableData[this.editingCell.row].id,
                    paramsToUpdate: {
                        [columnName]: this.tableData[this.editingCell.row][
                            columnName
                        ],
                    },
                })
                // reset the editing cell
                this.editingCell = {
                    row: null,
                    column: null,
                }
            } catch (error) {
                this.setErrorItems({
                    source: 'ItemForm',
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        startEditing(rowIndex, columnName) {
            this.editingCell = {
                row: rowIndex,
                column: columnName,
            }
        },
        async getItems() {
            try {
                this.loading = true
                this.tableData = await API.getLaborCostPerModule({
                    settingId: this.settingId,
                })
                if (this.tableData.length == 0) {
                    this.tableData = await API.createLaborCostPerModule({
                        settingId: this.settingId,
                    })
                }
                this.tableData.sort((a, b) => a.feet - b.feet)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async save() {
            try {
                this.loading = true
                await API.createLaborCostPerModule({
                    settingId: this.settingId,
                    items: this.tableData,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        // Format numbers as currency with $ prefix
        formatCurrency(value) {
            return `$${value.toFixed(2)}`
        },
    },
}
</script>

<style scoped>
.table-container {
    overflow-x: auto;
}

.cost-table {
    width: 100%;
    border-collapse: collapse;
}

.cost-table >>> th,
.cost-table >>> td {
    border: 1px solid #ddd;
    padding: 8px;
}

.width-label {
    writing-mode: vertical-rl;
    text-orientation: mixed;
    white-space: nowrap;
    text-align: center;
    font-weight: bold;
}

.price-cell.highlighted {
    color: #ff0000;
    font-weight: bold;
}
</style>
